// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { StopNetworkAreaRoutes } from '@backoffice-frontend/sam-common'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { StopNetworkAreaId } from './StopNetworkAreaId'

import {
  StopNetworkAreaNavigation,
  StopNetworkAreaNavigationIcon,
} from './StopNetworkAreaNavigation'

const LazyStopNetworkComponent = lazy(() => import('./StopNetworkArea'))

const StopNetworkComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyStopNetworkComponent />
  </SuspenseLoadingWrapper>
)

export const StopNetworkArea = {
  id: StopNetworkAreaId,
  requiredRight: BoumRight.AREA_STOP_NETWORK,
  Icon: StopNetworkAreaNavigationIcon,
  NavigationComponent: StopNetworkAreaNavigation,
  route: {
    path: StopNetworkAreaRoutes.route,
    component: StopNetworkComponent,
  },
}
